import React from "react";

const ContactChat = ({
  width = 61,
  height = 61,
}: {
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 61 61"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1185_45895)">
        <g clipPath="url(#clip1_1185_45895)">
          <g clipPath="url(#clip2_1185_45895)">
            <mask
              id="mask0_1185_45895"
              //   style="mask-type:luminance"
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="61"
              height="61"
            >
              <path
                d="M60.332 0.28125H0.332031V60.2812H60.332V0.28125Z"
                fill="white"
              />
            </mask>
            <g mask="url(#mask0_1185_45895)">
              <path
                d="M30.332 60.2812C46.9006 60.2812 60.332 46.8498 60.332 30.2812C60.332 13.7127 46.9006 0.28125 30.332 0.28125C13.7635 0.28125 0.332031 13.7127 0.332031 30.2812C0.332031 46.8498 13.7635 60.2812 30.332 60.2812Z"
                fill="#DDF3F6"
              />
              <path
                d="M30.8558 18.2812C37.6717 18.2812 42.8317 23.8696 42.8317 30.2631C42.8317 37.6782 36.7838 42.281 30.8318 42.281C28.8639 42.281 26.6799 41.7521 24.9279 40.7186C24.3159 40.346 23.7999 40.0697 23.1399 40.2861L20.716 41.0071C20.104 41.1994 19.552 40.7187 19.732 40.0697L20.536 37.3776C20.668 37.0051 20.644 36.6085 20.452 36.296C19.42 34.3972 18.832 32.3182 18.832 30.2992C18.832 23.9778 23.8839 18.2812 30.8558 18.2812ZM36.3398 28.7729C35.4878 28.7729 34.8038 29.4579 34.8038 30.3111C34.8038 31.1524 35.4878 31.8494 36.3398 31.8494C37.1917 31.8494 37.8757 31.1524 37.8757 30.3111C37.8757 29.4579 37.1917 28.7729 36.3398 28.7729ZM30.8078 28.7729C29.9678 28.7608 29.2719 29.458 29.2719 30.2992C29.2719 31.1525 29.9558 31.8374 30.8078 31.8494C31.6598 31.8494 32.3438 31.1524 32.3438 30.3111C32.3438 29.4579 31.6598 28.7729 30.8078 28.7729ZM25.2759 28.7729C24.4239 28.7729 23.7399 29.4579 23.7399 30.3111C23.7399 31.1524 24.4359 31.8494 25.2759 31.8494C26.1279 31.8374 26.8119 31.1524 26.8119 30.3111C26.8119 29.4579 26.1279 28.7729 25.2759 28.7729Z"
                fill="#133345"
              />
            </g>
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_1185_45895">
          <rect
            width="60"
            height="60"
            fill="white"
            transform="translate(0.332031 0.28125)"
          />
        </clipPath>
        <clipPath id="clip1_1185_45895">
          <rect
            width="60"
            height="60"
            fill="white"
            transform="translate(0.332031 0.28125)"
          />
        </clipPath>
        <clipPath id="clip2_1185_45895">
          <rect
            width="60"
            height="60"
            fill="white"
            transform="translate(0.332031 0.28125)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ContactChat;
